/* global history */
import {
    includes,
    without,
    concat,
    first,
    keys,
    reduce,
    join,
    uniq,
    map,
    split
} from 'lodash-es'

import {
    SELECT_CHECKBOX,
    SELECT_RADIO,
    CHANGE_PRICE_STATE, REGISTER_COMPONENT
} from '../actions/select'

import {
    parseDrupalJSON
} from '../utils/parsers'

import {
    getDefaults
} from '../selectors'

const updateHash = ({selections}) => {
    const hash = join(reduce(selections, (result, value, key) => {
        result.push(`${key}=${join(value, ',')}`);
        return result;
    }, []), '&');
    window.history.replaceState(null, '', '#' + hash);
};

const applyHash = (state) => {
    const {location: {hash}} = document;
    const {selections: defaultSelections} = state;
    if (hash) {
        const selections = reduce(split(hash.replace(/^#/, ''), '&'), (result, queryValue) => {
            const [key, value] = split(queryValue, '=');
            result[key] = value ? map(split(value, ','), Number) : [];
            return result;
        }, {...defaultSelections});
        return {
            ...state,
            selections: selections
        }
    }
    return state;
};

const handleSelectRadio = (state, {id, property}) => {
    let newSelections = [id];
    const isAlreadySelected = includes(state.selections[property], id);
    if (isAlreadySelected) {
        const propertyDefaults = getDefaults(state)[property];
        newSelections = propertyDefaults ? [first(propertyDefaults)] : []
    }
    return {
        ...state,
        selections: {
            ...state.selections,
            [property]: newSelections
        }
    }
};

const handleSelectCheckbox = (state, {id, property}) => {
    const {selections: {[property]: items}} = state;
    return {
        ...state,
        selections: {
            ...state.selections,
            [property]: includes(items, id) ? without(items, id) : concat(items, id)
        }
    };
};

const handleRegisterComponent = (state, {property}) => {
    const {registeredComponents} = state;
    return includes(registeredComponents, property) ? state : {
        ...state,
        registeredComponents: uniq(concat(registeredComponents, property))
    }
};

const {CONFIGURATOR, BOAT_ACCESSORIES, BOAT_PRICE, CURRENCY_SYMBOL} = window;
if (!CONFIGURATOR) {
    if (!BOAT_ACCESSORIES) {
        throw new Error('Missing data parameter window.BOAT_ACCESSORIES or window.CONFIGURATOR');
    }
    if (!BOAT_PRICE) {
        throw new Error('Missing data parameter window.BOAT_PRICE or window.CONFIGURATOR');
    }
}

const configuratorState = applyHash(CONFIGURATOR ? CONFIGURATOR : parseDrupalJSON(BOAT_ACCESSORIES, {price: BOAT_PRICE, currency: CURRENCY_SYMBOL}));
export const propertyKeys = keys(configuratorState);
const initialState = {
    ...configuratorState,
    hasChanged: false,
    registeredComponents: []
};

export const options = (state = initialState, action) => {
    const {payload} = action;
    let newState;
    switch (action.type) {
        case SELECT_RADIO:
            newState = handleSelectRadio(state, payload);
            break;
        case SELECT_CHECKBOX:
            newState = handleSelectCheckbox(state, payload);
            break;
        case REGISTER_COMPONENT:
            return handleRegisterComponent(state, payload);
        case CHANGE_PRICE_STATE:
            return {
                ...state,
                hasChanged: action.payload
            };
        default:
            newState = state;
    }
    if (!newState !== state) {
        updateHash(newState);
    }
    return newState;
};



// WEBPACK FOOTER //
// ./src/reducers/index.js